export function changeCurrentTheme(currentTheme) {
  return {
    type: '@theme/SET_CURRENT_THEME',
    payload: { currentTheme },
  }
}
